import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

export default function SectionTitle({ translationKey, sx }) {
  const { t } = useTranslation();

  return (
    <Typography
      variant="h6"
      component="h2"
      sx={{
        textAlign: "left",
        fontWeight: "bold",
        color: "#0C343D",
        textTransform: "uppercase",
        mt: 3,
        mb: 2,
        borderBottom: "2px solid #004d40",
        pb: 1,
        ...sx,
      }}
    >
      {t(translationKey)}
    </Typography>
  );
}
